import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { SitePage } from '../Models/SitePage';
import { ResponseModel } from '../Models/ResponseModel';

class SitePageApi {
  static getSitePage(id: string) {
    return axios.get<SitePage>(
      `${API_URL}/api/sitepage/GetSitePage/${id}`,
      getAuthHeader()
    );
  }

  static getPublicSitePage(id: number) {
    return axios.get<SitePage>(
      `${API_URL}/api/sitepage/public/${id}`,
      getAuthHeader()
    );
  }

  static copySitePage(id: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/sitepage/copy/${id}`,
      {},
      getAuthHeader()
    );
  }

  static addUpdateSitePage(request: SitePage) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/sitepage/CreateUpdatePage`,
      request,
      getAuthHeader()
    );
  }

  static getSitePageList() {
    return axios.get<SitePage[]>(
      `${API_URL}/api/sitepage/GetSitePages`,
      getAuthHeader()
    );
  }

  static getSitePageListForMenu() {
    return axios.get<SitePage[]>(
      `${API_URL}/api/sitepage/GetSitePagesMenu`,
      getAuthHeader()
    );
  }

  static getMyMemberPage() {
    return axios.get<SitePage>(
      `${API_URL}/api/sitepage/GetMyMemberPage`,
      getAuthHeader()
    );
  }

  static getMemberPageById(memberId: number) {
    return axios.get<SitePage>(
      `${API_URL}/api/sitepage/GetMemberPage/${memberId}`,
      getAuthHeader()
    );
  }

  static validateMemberHtml(html: string | null) {
    return axios.post<{ valid: boolean; errorMessage?: string }>(
      `${API_URL}/api/sitepage/ValidateMemberHtml`,
      { html: html ?? "" },
      getAuthHeader()
    );
  }
}

export default SitePageApi;
